import 'antd/lib/date-picker/style/index.less';
import type { Dayjs } from '@iqx-web/libs/dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/lib/date-picker/generatePicker';

export const BaseDatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export * from './types';
export * from './DatePicker';
export * from './TimeDatePicker';
